// extracted by mini-css-extract-plugin
export var actions = "_4c-0";
export var actionsContainer = "_4c-8";
export var border = "_4c-1";
export var childFullHeight = "_4c-f";
export var collapse = "_4c-2";
export var content = "_4c-a";
export var contentChild = "_4c-e";
export var fullscreen = "_4c-c";
export var hasLeftRadius = "_4c-r";
export var headerContainer = "_4c-3";
export var headerRow = "_4c-5";
export var hidePadding = "_4c-b";
export var navCollapsedGap = "_4c-s";
export var noScrollX = "_4c-t";
export var noScrollY = "_4c-u";
export var noTopPadding = "_4c-p";
export var optOutTopPadding = "_4c-d";
export var outletContent = "_4c-l";
export var outletContentInner = "_4c-m";
export var outletLeadingPanel = "_4c-i";
export var outletLeadingPanelAttention = "_4c-j";
export var outletNoScroll = "_4c-7";
export var outletResizeDivider = "_4c-k";
export var outletSplit = "_4c-g";
export var outletSplitResizing = "_4c-h";
export var pageMain = "_4c-q";
export var pageOuter = "_4c-n";
export var pagePadding = "_4c-9";
export var profile = "_4c-v";
export var profileContainer = "_4c-w";
export var profileImage = "_4c-x";
export var profileMain = "_4c-y";
export var profileSubtitle = "_4c-10";
export var profileTitle = "_4c-z";
export var showLeftPadding = "_4c-o";
export var tabsPortalSlot = "_4c-6";
export var tabsWrapper = "_4c-4";
export var title = "_4c-11";